module.exports = __webpack_public_path__ + "img/Weapon_256.561eaa29.png";